export function scrollToTop(): void {
  if (window.scrollY === 0) return;
  window.scrollTo(0, 0);
}
